var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['black-button', _vm.icon],on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":("/icons/" + _vm.icon + ".svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }